module.exports = __webpack_public_path__ + "static/media/29DUNON15.1e9f4753.jpg";